<template>
  <div class="menus-page">
    <div class="menus-hero">
      <div>
        <p class="hero-kicker mb-1">ناوبری فروشگاه و وبلاگ</p>
        <h1 class="mb-0">پنل مدیریت منو ها</h1>
      </div>
      <div class="hero-side">
        <div class="hero-count">
          <strong>{{ safeMenus.length }}</strong>
          <span>منو</span>
        </div>
        <div class="hero-badge">
          <b-icon icon="list-nested"></b-icon>
        </div>
      </div>
    </div>

    <div class="menus-toolbar">
      <div class="menus-toolbar-actions">
        <button type="button" class="menus-tool-btn is-primary" v-b-modal.modal>
          <b-icon icon="plus-lg"></b-icon>
          <span>ایجاد منو جدید</span>
        </button>
        <data-import-manager class="menus-tool-slot" data-type="menu" @imported="getItems"/>
        <data-export class="menus-tool-slot" data-type="menu"/>
      </div>
      <LanguageSelectBox class="menus-lang" @changeLanguage="getItems" module-name="menu"/>
    </div>

    <div class="menus-section-title">
      <b-icon icon="layout-three-columns"></b-icon>
      <span>جایگاه منوها</span>
    </div>

    <div class="menus-positions">
      <section class="menus-position-card" v-for="menuPosition in menuPositions" :key="menuPositions.indexOf(menuPosition)">
        <div class="menus-position-head">
          <button type="button" class="menus-position-toggle" v-b-toggle="'collapse-'+menuPosition.value">
            <span class="menus-position-icon"><b-icon icon="menu-button-wide"></b-icon></span>
            <span class="menus-position-text">
              <strong>{{ menuPosition.text }}</strong>
              <small dir="ltr">{{ menuPosition.value }}</small>
            </span>
            <span class="menus-chip" :class="{ 'is-active': activeMenusOf(menuPosition.value).length }">
              {{ activeMenusOf(menuPosition.value).length ? 'فعال' : 'بدون منو' }}
            </span>
            <b-icon icon="chevron-down" class="menus-chevron"></b-icon>
          </button>
          <button type="button" class="menus-tool-btn is-warning"
                  v-b-modal="menuPosition.value"
                  @click="setSelectMenuForm(menuPosition.value)">
            <b-icon icon="arrow-left-right"></b-icon>
            <span>تغییر منو</span>
          </button>
        </div>

        <ChangeMenuModalForm
            :menu-position="menuPosition"
            :select-menu="selectMenu"
            :select-options="selectOptions"
            :menus="menus"
        />

        <b-collapse :id="'collapse-'+menuPosition.value" role="tabpanel">
          <div class="menus-position-body">
            <div v-if="!activeMenusOf(menuPosition.value).length" class="menus-empty is-small">
              <span>منویی برای این جایگاه فعال نشده است.</span>
            </div>
            <div v-for="menu in activeMenusOf(menuPosition.value)" :key="menu.id" class="menus-row">
              <span class="menus-color" :style="{ background: menu.background || '#fff' }"></span>
              <span class="menus-row-name">{{ menu.name }}</span>
              <div class="menus-row-actions">
                <router-link class="menus-action" title="ویرایش" :to="{name:'EditMenu', params:{id:menu.id}}">
                  <b-icon icon="pen"/>
                </router-link>
                <button type="button" class="menus-action is-danger" title="حذف" @click="removeMenu(menu.id)">
                  <b-icon icon="trash"/>
                </button>
              </div>
            </div>
          </div>
        </b-collapse>
      </section>
    </div>

    <div class="menus-section-title">
      <b-icon icon="collection"></b-icon>
      <span>لیست منوهای ساخته شده</span>
      <span class="menus-chip">{{ safeMenus.length }}</span>
    </div>

    <div class="menus-list-panel">
      <div v-if="!safeMenus.length" class="menus-empty">
        <b-icon icon="list-nested"></b-icon>
        <span>هنوز منویی ساخته نشده است.</span>
        <button type="button" class="menus-empty-btn" v-b-modal.modal>ایجاد منو جدید</button>
      </div>
      <div v-else class="menus-grid">
        <article v-for="menu in safeMenus" :key="menu.id" class="menus-card">
          <div class="menus-card-top">
            <span class="menus-id-chip">#{{ menu.id }}</span>
            <span v-if="menu.status === 1" class="menus-chip is-active">فعال</span>
          </div>
          <div class="menus-card-name">
            <span class="menus-color" :style="{ background: menu.background || '#fff' }"></span>
            <span>{{ menu.name }}</span>
          </div>
          <div class="menus-card-meta" v-if="menu.position">
            <b-icon icon="geo"></b-icon>
            <span>{{ positionText(menu.position) }}</span>
          </div>
          <div class="menus-card-actions">
            <router-link class="menus-action is-main" :to="{name:'EditMenu', params:{id:menu.id}}">
              <b-icon icon="pen"/>
              <span>ویرایش آیتم‌ها</span>
            </router-link>
            <button type="button" class="menus-action is-danger" title="حذف" @click="removeMenu(menu.id)">
              <b-icon icon="trash"/>
            </button>
          </div>
        </article>
      </div>
    </div>

    <b-modal id="modal" ref="modal" centered scrollable hide-header-close
             modal-class="menus-modal" @ok="onSubmit">
      <template #modal-header="{ cancel }">
        <menu-modal-header icon="plus-square" title="ایجاد منو جدید"
                           subtitle="عنوان و زبان منو را مشخص کنید." @close="cancel()"/>
      </template>

      <form @submit.stop.prevent="onSubmit">
        <form-group :validations="$v.newMenu.name">
          <div slot-scope="{ errors, invalid }" class="menus-modal-field">
            <label>عنوان منو</label>
            <b-form-input type="text" v-model="newMenu.name" placeholder="عنوان منو"/>
            <form-errors-manager :errors="errors"/>
          </div>
        </form-group>

        <form-group :validations="$v.newMenu.language_id">
          <div slot-scope="{ errors, invalid }" class="menus-modal-field">
            <label>زبان</label>
            <select class="custom-select" v-model="newMenu.language_id">
              <option value="">انتخاب زبان</option>
              <option v-for="language in languages" :value="language.id">{{ language.name }}</option>
            </select>
            <form-errors-manager :errors="errors"/>
          </div>
        </form-group>
      </form>

      <template #modal-footer="{ ok, cancel }">
        <div class="menus-modal-actions">
          <button type="button" class="menus-btn is-primary" @click="ok()">
            <b-icon icon="check2"></b-icon>
            <span>اضافه کردن آیتم</span>
          </button>
          <button type="button" class="menus-btn" @click="cancel()">انصراف</button>
        </div>
      </template>
    </b-modal>

  </div>
</template>

<script>
import {mapGetters} from "vuex";
import FormGroup from "../../components/validator/FormGroup";
import {required, minLength, maxLength, numeric} from "vuelidate/lib/validators";
import FormErrorsManager from '../../components/validator/FormErrorsManager.vue'
import ChangeMenuModalForm from "../../components/dashboard/menu/ChangeMenuModalForm";
import LanguageSelectBox from "../../components/dashboard/Language/LanguageSelectBox";
import DataImportManager from "../../components/dashboard/DataImport/DataImportManager.vue";
import DataExport from "../../components/dashboard/DataExport/DataExport.vue";
import MenuModalHeader from "../../components/dashboard/menu/MenuModalHeader.vue";
import "../../components/dashboard/menu/menus-ui.css";

export default {
  name: "Menus",
  components: {MenuModalHeader, DataExport, DataImportManager, FormGroup, FormErrorsManager, ChangeMenuModalForm, LanguageSelectBox},
  data() {
    return {
      menuPositions: [
        {text: 'منو اصلی فروشگاه', value: 'store_nav'},
        {text: 'منو فوتر سایت', value: 'store_footer'},
        {text: 'منو اصلی وبلاگ', value: 'blog_nav'},
        {text: 'منو فوتر وبلاگ', value: 'blog_footer'}],
      newMenu: {
        status: false,
        position: null,
        name: '',
        language_id: '',
        background: '#FFFFFF'
      },
      selectMenu: {position: null, menu_id: null},
      selectOptions: []
    }
  },
  validations: {
    newMenu: {
      status: {required},
      language_id: {required},
      name: {required},
    }
  },
  computed: {
    ...mapGetters({
      menus: "Menu/getAllMenus",
      languages: 'Language/getLanguages'
    }),
    safeMenus() {
      return Array.isArray(this.menus) ? this.menus : []
    }
  },
  methods: {
    positionText(position) {
      const found = this.menuPositions.find(item => item.value === position)
      return found ? found.text : position
    },
    activeMenusOf(position) {
      return this.safeMenus.filter(menu => menu.position === position && menu.status === 1)
    },
    handleOk(form) {
      this.$store.dispatch("Menu/createMenu", form)
    },
    removeMenu(menuId) {
      let text = "آیا از حذف منو اطمینان دارید؟";
      if (confirm(text) === true) {
        this.$store.dispatch("Menu/deleteMenu", menuId)
      }
    },
    setSelectMenuForm(positionValue) {
      let options = []
      this.menus.forEach(element => (options.push({text: element.name, value: element.id})))

      this.selectOptions = options
      this.selectMenu.position = positionValue
    },
    resetSelectMenu() {
      this.selectMenu = {position: null, menu_id: null}
    },
    invalid() {
      this.$v.$touch();
      return !this.$v.$invalid;
    },
    onSubmit(bvModalEvent) {
      bvModalEvent.preventDefault()
      if (this.invalid()) {
        let form = this.newMenu
        this.handleOk(form);
        this.$nextTick(() => {
          this.$bvModal.hide('modal')
        })
      }
    },
    getItems() {
      this.$store.dispatch("Menu/getMenus")
    }
  },
  mounted() {
    this.getItems();
  }
}
</script>
